export default "__VITE_ASSET__BoAm_BGG__"